import { defineStore } from 'pinia';

export default defineStore('snackbar', () => {
  const visibility = ref(false);
  const message = ref('');
  const list = ref<string[]>([]);
  const timer = ref(-1);
  const color = ref<string | undefined>();
  const icon = ref<string | null>(null);

  const showSnackbar = (params: any = {}) => {
    const { text = '', items = [], state = null, sign = null, delay = 4000 } = params;

    visibility.value = true;
    message.value = text;
    list.value = items;
    timer.value = delay;

    if (typeof state === 'boolean') {
      color.value = state ? 'success' : 'error';
    } else if (state === null) {
      color.value = '#000';
    } else {
      color.value = state;
    }

    if (sign) {
      icon.value = sign;
    } else {
      switch (color.value) {
        case 'success':
          icon.value = 'mdi-check-circle';
          break;
        case 'warning':
          icon.value = 'mdi-alert-outline';
          break;
        case 'error':
          icon.value = 'mdi-trash-can';
          break;
        case 'info':
          icon.value = 'mdi-information-outline';
          break;
        default:
          icon.value = sign;
          break;
      }
    }
  };

  const clearSnackbar = () => {
    visibility.value = false;
    message.value = '';
    list.value = [];
    timer.value = 4000;
    color.value = undefined;
    icon.value = null;
  };

  return { visibility, message, list, timer, color, icon, showSnackbar, clearSnackbar };
});
